import { AxiosError } from "axios";

import { PRODUCT_DOMAIN } from "@/constants";
import axioInstance from "@/libs/axios";
import { SecurityQuestions } from "@/types/policy-document-types";

export const useSubmitWithdrawalData = (
  withdrawalId: string | null | undefined
) => {
  const submitWithdrawalData = async (
    securityQuestions: SecurityQuestions | null
  ) => {
    if (!withdrawalId) {
      throw new Error("Withdrawal ID is required");
    }
    try {
      const requestData = {
        type: "Policy",
        channel: "ONLINE",
        attributes: {
          domain: PRODUCT_DOMAIN,
          securityQuestionRequest: { answers: securityQuestions },
        },
      };

      // Call backend API directly through axioInstance
      const response = await axioInstance.post(
        `policy/${withdrawalId}/withdrawal/authenticate`,
        { data: requestData }
      );

      const responseCode = response.data?.code;
      const isSuccess = responseCode === 200;
      const securityQuestionResponse =
        response.data?.data?.attributes?.securityQuestionResponse;

      return {
        success: isSuccess,
        code: responseCode,
        isValidationFailed:
          !securityQuestionResponse?.valid && responseCode === 1063,
        isTooManyAttempts: responseCode === 1062,
        remainingAttempts: securityQuestionResponse?.remainingAttempts,
        data: response.data,
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      // eslint-disable-next-line no-console
      console.error("Withdrawal authentication error:", axiosError);
      const statusCode = axiosError.response?.status;

      return {
        success: false,
        statusCode,
        isValidationFailed: false,
        isTooManyAttempts: false,
        remainingAttempts: undefined,
        data: axiosError.response?.data,
      };
    }
  };
  return submitWithdrawalData;
};
